// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"kq-z","slideIn":"lq-z"};